import { InvoiceIntegrationModel } from "./InvoiceIntegrationModel";
export class InvoiceAccountingIntegration {
  static fromDTO(dto) {
    return new InvoiceAccountingIntegration(InvoiceIntegrationModel.fromScoutDTO(dto.integration), dto.isSync);
  }
  constructor(integration, isSync) {
    this.integration = integration;
    this.isSync = isSync;
  }
  isSynced() {
    return this.integration.isSynced() && this.isSync;
  }
  isRefundRecorded() {
    return this.integration.isRefundRecorded();
  }
  isPaymentRecorded() {
    return this.integration.isPaymentRecorded();
  }
  getIntegration() {
    return this.integration;
  }
  setIntegration(integration) {
    this.integration = integration;
  }
  setIsSync(isSync) {
    this.isSync = isSync;
  }
}